var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { DelegationOption } from '@/common/types/DelegationOption';
import RadioButtonOptionRow from '@/common/components/RadioButtonOptionRow.vue';
import NumericInputRow from '@/common/components/NumericInputRow.vue';
import MinMaxInputRow from '@/template/components/aidApplication/budgetaryEstimate/MinMaxInputRow.vue';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import HeaderControl from '@/common/components/HeaderControl.vue';
import EstimatesControl from '@/template/components/aidApplication/budgetaryEstimate/EstimatesControl.vue';
import { DelegatedAid } from "@/common/types/DelegatedAid";
import { Savable } from '@/common/mixins/Savable';
import Estimates from '@/common/types/Estimates';
var DelegationControl = /** @class */ (function (_super) {
    __extends(DelegationControl, _super);
    function DelegationControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.radioButtonValueChanged = "";
        _this.delegationOptions = [
            { id: DelegationOption.NotDelegated, name: "BudgetaryEstimate.Delegation.NotDelegated", confirmRadioClean: _this.cleanSelected },
            { id: DelegationOption.DelegatedToMember, name: "BudgetaryEstimate.Delegation.DelegatedToMember", confirmRadioClean: _this.cleanSelected },
            { id: DelegationOption.DelegatedToPartner, name: "BudgetaryEstimate.Delegation.DelegatedToPartner", confirmRadioClean: _this.cleanSelected }
        ];
        return _this;
    }
    DelegationControl.prototype.cleanSelected = function (current) {
        if (current == DelegationOption.DelegatedToMember) {
            if (this.memberModified()) {
                if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.Delegation").toString())) {
                    this.resetMemberData();
                    return true;
                }
                this.delegatedAid.delegatedTo = current;
                this.radioButtonValueChanged = Date();
                return false;
            }
        }
        else if (current == DelegationOption.DelegatedToPartner) {
            if ((this.delegatedAid.yearlyPartnerDelegationTotals.length == 1 && this.estimateItemNotEmpty(this.delegatedAid.yearlyPartnerDelegationTotals[0]))
                || this.delegatedAid.yearlyPartnerDelegationTotals.length > 1
                || this.delegatedAid.yearlyPartnerDelegationTotals[0].name) {
                if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.Delegation").toString())) {
                    this.delegatedAid.yearlyPartnerDelegationTotals = [];
                    this.radioButtonValueChanged = Date();
                    return true;
                }
                this.delegatedAid.delegatedTo = current;
                this.radioButtonValueChanged = Date();
                return false;
            }
        }
        return true;
    };
    DelegationControl.prototype.memberModified = function () {
        if (this.estimateItemNotEmpty(this.delegatedAid.yearlyMemberDelegationTotals[0])
            || (this.delegatedAid.sumMax || this.delegatedAid.sumMax == 0)
            || (this.delegatedAid.sumMin || this.delegatedAid.sumMin == 0)
            || (this.delegatedAid.amountOfTargets || this.delegatedAid.amountOfTargets == 0))
            return true;
        return false;
    };
    DelegationControl.prototype.estimateItemNotEmpty = function (estimateItem) {
        var e_1, _a;
        try {
            for (var _b = __values(estimateItem.yearlyItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                var yearlyItem = _c.value;
                if (yearlyItem.value || yearlyItem.value == 0)
                    return true;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    DelegationControl.prototype.onPropertyChange = function () {
        if (this.delegatedAid.delegatedTo == DelegationOption.DelegatedToPartner && this.delegatedAid.yearlyPartnerDelegationTotals.length === 0) {
            this.delegatedAid.yearlyPartnerDelegationTotals.push(this.createEstimate());
        }
    };
    Object.defineProperty(DelegationControl.prototype, "memberEstimates", {
        get: function () {
            return new Estimates(this.delegatedAid.yearlyMemberDelegationTotals);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DelegationControl.prototype, "partnerEstimates", {
        get: function () {
            return new Estimates(this.delegatedAid.yearlyPartnerDelegationTotals);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DelegationControl.prototype, "DelegationOption", {
        get: function () {
            return DelegationOption;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DelegationControl.prototype, "hasProcuration", {
        get: function () {
            return this.$store.state.vuexPageModule.currentUser.hasProcuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DelegationControl.prototype, "showPartners", {
        get: function () {
            return this.delegatedAid.delegatedTo == DelegationOption.DelegatedToPartner;
        },
        enumerable: false,
        configurable: true
    });
    DelegationControl.prototype.indexAsString = function (index) {
        return index.toString();
    };
    DelegationControl.prototype.resetMemberData = function () {
        var e_2, _a;
        try {
            for (var _b = __values(this.delegatedAid.yearlyMemberDelegationTotals[0].yearlyItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                item.value = null;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.delegatedAid.amountOfTargets = null;
        this.delegatedAid.sumMin = null;
        this.delegatedAid.sumMax = null;
    };
    var _a;
    __decorate([
        Prop(Object),
        __metadata("design:type", typeof (_a = typeof DelegatedAid !== "undefined" && DelegatedAid) === "function" ? _a : Object)
    ], DelegationControl.prototype, "delegatedAid", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], DelegationControl.prototype, "title", void 0);
    __decorate([
        Prop({ type: Function }),
        __metadata("design:type", Function)
    ], DelegationControl.prototype, "createEstimate", void 0);
    __decorate([
        Watch("delegatedAid.delegatedTo"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DelegationControl.prototype, "onPropertyChange", null);
    DelegationControl = __decorate([
        Component({
            name: "DelegationControl",
            components: {
                RadioButtonOptionRow: RadioButtonOptionRow,
                NumericInputRow: NumericInputRow,
                TextAreaRow: TextAreaRow,
                HeaderControl: HeaderControl,
                MinMaxInputRow: MinMaxInputRow,
                EstimatesControl: EstimatesControl
            }
        })
    ], DelegationControl);
    return DelegationControl;
}(Mixins(Savable)));
export default DelegationControl;
